<micro-select-combo #sel
              placeholder="Auth"
              [mode]="mode"
              [(id)]="auth"
              (idChange)="change($event)"
              [required]="required"
              [options]="options"
              [disabled]="disabled"
              valueField="auth"
>
</micro-select-combo>
